import { PAGE_TYPE, CLASSIFICATION_TYPE } from "../../../../constants";
import { eventTrackPayloadCreator } from "../../../../helpers/eventPayloadCreator";
import { EventData } from "../../../../types";
import { BasePreOrderAnalyticsPayload } from "../../../page/preorder/types";

export type ClickCheckAgainTrackEvent = BasePreOrderAnalyticsPayload;

const ClickCheckAgainAnalyticsEvent: EventData = {
  pageDetail: "Hang Tight Page",
  pageType: PAGE_TYPE.checkout,
  eventName: "Click Check Again",
  classification: CLASSIFICATION_TYPE.coreBuyFlow,
};

export const OrderPendingClickCheckAgainEventPayload =
  eventTrackPayloadCreator<ClickCheckAgainTrackEvent>(
    ClickCheckAgainAnalyticsEvent,
  );
